export default "__VITE_ASSET__CimCw86t__"